export default function ProcessIconTwo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="72"
      fill="none"
      viewBox="0 0 72 72"
    >
      <rect width="72" height="72" fill="#FFF3E6" rx="36" />
      <path
        fill="#F80"
        d="M28 20h10v8c0 1.125.875 2 2 2h8v18c0 2.25-1.813 4-4 4H28c-2.25 0-4-1.75-4-4V24c0-2.188 1.75-4 4-4Zm12 0 8 8h-8v-8Zm1 19c0-3.313-2.688-6-6-6-3.313 0-6 2.688-6 6 0 3.313 2.688 6 6 6 1.063 0 2.125-.25 3-.813l2.438 2.438c.562.563 1.5.563 2.124 0 .563-.625.563-1.563 0-2.125l-2.437-2.438A5.66 5.66 0 0 0 41 39Zm-6 3c-1.125 0-2.063-.563-2.625-1.5-.563-.875-.563-2.063 0-3 .563-.875 1.5-1.5 2.625-1.5 1.063 0 2 .625 2.563 1.5.562.938.562 2.125 0 3C37 41.438 36.063 42 35 42Z"
      />
    </svg>
  )
}
